export default [{
  path: '/view/department',
  name: 'viewdepartment',
  component: () => import('@/app/department/DepartmentView'),
  meta: {
    resource: 'departments',
    actions: ['read']
  }
}]
